import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-5 mb-1" }, "Application Center List")
], -1)
const _hoisted_4 = {
  class: "card-toolbar",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  "data-bs-trigger": "hover",
  title: "Click to add tasks"
}
const _hoisted_5 = {
  href: "#",
  class: "btn btn-sm btn-light-success p-1 pe-4",
  "data-bs-toggle": "modal",
  "data-bs-target": "#add_application_modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1qh" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fs-9" }, "New Application", -1)
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          value: "1"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px fs-7" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-auto fs-7" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-auto fs-7" }, "Created"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px fs-7" }, "Updated"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px fs-7" }, "Progress"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px fs-7 text-end" }, "Actions")
  ])
], -1)
const _hoisted_12 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_16 = {
  href: "#",
  class: "text-gray-700 fw-bolder text-hover-primary fs-8"
}
const _hoisted_17 = { class: "text-muted fw-bold text-muted d-block fs-8" }
const _hoisted_18 = {
  href: "#",
  class: "text-gray-700 fw-bolder text-hover-primary d-block fs-8"
}
const _hoisted_19 = { class: "text-muted fw-bold text-muted d-block fs-8" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-gray-700 fw-bolder text-hover-primary d-block fs-8"
}, null, -1)
const _hoisted_21 = { class: "text-muted fw-bold text-muted d-block fs-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-gray-700 fw-bolder text-hover-primary d-block fs-7"
}, null, -1)
const _hoisted_23 = { class: "text-muted fw-bold text-muted d-block fs-8" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "d-flex flex-column w-100 me-2 bg-light-warning" }
const _hoisted_26 = ["aria-valuenow"]
const _hoisted_27 = { class: "d-flex flex-column w-100 me-2 bg-light-primary" }
const _hoisted_28 = ["aria-valuenow"]
const _hoisted_29 = { class: "d-flex flex-column w-100 me-2 bg-light-success" }
const _hoisted_30 = ["aria-valuenow"]
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "svg-icon svg-icon-3" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "svg-icon svg-icon-3" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "svg-icon svg-icon-3" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "svg-icon svg-icon-2x ms-n" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_AddApplicationModal = _resolveComponent("AddApplicationModal")!
  const _component_AdminApplicationDrawer = _resolveComponent("AdminApplicationDrawer")!
  const _component_SmsMessageModal = _resolveComponent("SmsMessageModal")!
  const _component_IboEmailModal = _resolveComponent("IboEmailModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
            ]),
            _hoisted_7
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationCenterList, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("input", {
                        class: "form-check-input widget-9-check",
                        type: "checkbox",
                        value: index
                      }, null, 8, _hoisted_13)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("a", _hoisted_16, _toDisplayString(item.adminfullname), 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(item.app_id), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", _hoisted_18, _toDisplayString(item.adminemail), 1),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(item.adminphone), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString(item.date_created), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _hoisted_22,
                    _createElementVNode("span", _hoisted_23, _toDisplayString(item.datelastmodified), 1)
                  ]),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (item.app_progress < 50.0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "progress-bar bg-light-warning text-gray-700 fs-9 fw-normal p-1",
                            role: "progressbar",
                            style: { width: 35 + '%' },
                            "aria-valuenow": item.app_progress,
                            "aria-valuemin": "1",
                            "aria-valuemax": "100"
                          }, _toDisplayString(item.app_progress) + "% ", 9, _hoisted_26))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      (
                        item.app_progress > 49.0 && item.app_progress < 79.0
                      )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "progress-bar bg-primary fs-9 fw-normal p-1",
                            role: "progressbar",
                            style: _normalizeStyle({ width: item.app_progress + '%' }),
                            "aria-valuenow": item.app_progress,
                            "aria-valuemin": "1",
                            "aria-valuemax": "100"
                          }, _toDisplayString(item.app_progress) + "% ", 13, _hoisted_28))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      (item.app_progress >= 80.0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "progress-bar bg-success fs-9 fw-normal p-1",
                            role: "progressbar",
                            style: _normalizeStyle({ width: item.app_progress + '%' }),
                            "aria-valuenow": item.app_progress,
                            "aria-valuemin": "1",
                            "aria-valuemax": "100"
                          }, _toDisplayString(item.app_progress) + "% ", 13, _hoisted_30))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_31, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: ($event: any) => (_ctx.openDrawer(item)),
                      "data-bs-toggle": "tooltip",
                      "data-bs-placement": "top",
                      "data-bs-trigger": "hover",
                      title: "Documents",
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                    }, [
                      _createElementVNode("span", _hoisted_33, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil012.svg" })
                      ])
                    ], 8, _hoisted_32),
                    _createElementVNode("a", {
                      type: "button",
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                      onClick: ($event: any) => (_ctx.openEmailModal(item))
                    }, [
                      _createElementVNode("span", _hoisted_35, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com010.svg" })
                      ])
                    ], 8, _hoisted_34),
                    _createElementVNode("a", {
                      type: "button",
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                      onClick: ($event: any) => (_ctx.openSmsModal(item))
                    }, [
                      _createElementVNode("span", _hoisted_37, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/communication/com003.svg" })
                      ])
                    ], 8, _hoisted_36),
                    _createElementVNode("a", {
                      type: "button",
                      onClick: ($event: any) => (_ctx.onDeleteApplication(item.app_id)),
                      class: "btn btn-icon btn-bg-light-danger btn-active-color-primary btn-sm me-1 disabled"
                    }, [
                      _createElementVNode("span", _hoisted_39, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr088.svg" })
                      ])
                    ], 8, _hoisted_38)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode(_component_AddApplicationModal, { onSubmit: _ctx.getApplicationCenterList }, null, 8, ["onSubmit"]),
      _createVNode(_component_AdminApplicationDrawer, {
        merchant: _ctx.selectedMerchant,
        app_id: _ctx.selectedMerchant.app_id,
        onSubmit: _ctx.onUpdateIboApplication
      }, null, 8, ["merchant", "app_id", "onSubmit"])
    ]),
    _createVNode(_component_SmsMessageModal, {
      app_id: _ctx.selectedMerchant.app_id,
      ibo_id: _ctx.selectedMerchant.ibo_id
    }, null, 8, ["app_id", "ibo_id"]),
    _createVNode(_component_IboEmailModal, {
      app_id: _ctx.selectedMerchant.app_id,
      ibo_id: _ctx.selectedMerchant.ibo_id
    }, null, 8, ["app_id", "ibo_id"])
  ], 64))
}